import PeopleIcon from '@material-ui/icons/People'
import InfoEngagementsTab from '../components/tenant/department/tab/InfoEngagementsTab'
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd'
import EmailIcon from '@material-ui/icons/Email'
import InfoEmailTab from '../components/tenant/department/tab/InfoEmailTab'
import InfoDepartmentTenantsTab from '../components/tenant/department/tab/InfoDepartmentTenantsTab'

export const infoDepartmentRoutes = [
  {
    path: '/dashboard/info/tenants',
    name: 'Bewohner',
    icon: PeopleIcon,
    component: InfoDepartmentTenantsTab,
  },
  {
    path: '/dashboard/info/referate',
    name: 'Referate',
    icon: AssignmentIndIcon,
    component: InfoEngagementsTab,
  },
  {
    path: '/dashboard/info/email',
    name: 'E-Mail',
    icon: EmailIcon,
    component: InfoEmailTab,
  },
]
